import { makeStyles } from "@material-ui/core";
import { theme } from "../../../../../../../styles/TesaTheme";

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  header: {
    marginBottom: theme.spacing(2),
  },
  container: {
    padding: "2rem",
  },
  icon: {
    cursor: "pointer",
    position: "absolute",
    right: "1.6875rem",
    top: "2.3125rem",
  },
  rowInfo: {
    fontSize: "1rem",
    marginBottom: theme.spacing(2),
  },
  confirmationText: {
    letterSpacing: 0.5,
    lineHeight: "1.5rem",
    fontSize: "1rem",
  },
  spanLabel: {
    opacity: 0.5,
  },
  stretch: {
    minHeight: "25vh",
  },
});

export default useStyles;
